import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Models
 */
const gltfLoader = new GLTFLoader()

// Object
/* const geometry = new THREE.BoxGeometry(1, 1, 1)
const material = new THREE.MeshBasicMaterial({ color: 0xff0000 })
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh) */


gltfLoader.load(
    '/models/4scene.glb',
    (gltf) =>
    {
        gltf.scene.scale.set(1, 1, 1)
    
        gltf.scene.position.set(0,-1.5,0)
        scene.add(gltf.scene)
        gltf.scene.rotation.y
        console.log(gltf)
    }
)
 const spotLight = new THREE.SpotLight( 0x202020,4.5 );
spotLight.position.set( 0, 0, 10);
scene.add( spotLight );
/* const spotLight2 = new THREE.SpotLight( 0xffffff,1, );
spotLight2.position.set( 0, 0, -10);
scene.add( spotLight2 );  */

const light = new THREE.AmbientLight( 0xffffff, 0.5 ); // soft white light
scene.add( light );
// Crear la luz direccional
const directionalLight = new THREE.DirectionalLight(0x3D85C6, 1);
directionalLight.position.set(0, 1, 0);
 scene.add(directionalLight); 

// Crear un indicador direccional (ArrowHelper)
const dir = new THREE.Vector3(1, 0, 0); // Dirección de la flecha (x, y, z)
const origin = new THREE.Vector3(0, 0, 0); // Origen de la flecha
const length = 2; // Longitud de la flecha
const hex = 0xffff00; // Color de la flecha

const arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
/* scene.add(arrowHelper); */

// Actualizar la dirección de la flecha para que coincida con la luz direccional
arrowHelper.setDirection(directionalLight.position.normalize());

/* const ambiLigh2t = new THREE.AmbientLight(0xffffff,0.6,);
ambiLigh2t.position.set (0,0,25); */
/* scene.add (ambiLigh2t); */

/* const spotLightHelper = new THREE.SpotLightHelper( spotLight );
scene.add( spotLightHelper ); */

/* const spotLight = new THREE.SpotLight( 0xFFFFFF,20,400,100,1 );
//                      x  y  z
spotLight.position.set( 0, -0.5, 3 );
scene.add( spotLight );

const spotLightHelper = new THREE.SpotLightHelper( spotLight );
//scene.add( spotLightHelper ); 
 */

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.widths, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3
camera.position.y = 0
camera.position.x = 1
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.autoRotate=true
controls.autoRotateSpeed = 0.3
controls.enableZoom = false



// Renderer
const renderer = new THREE.WebGLRenderer({ alpha:true, canvas: canvas})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
//! Cambiar color de fondo
//renderer.setClearColor(new THREE.Color(0x2B2D30));

// Animate
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()